export default [
  {
    name: 'carQuery',
    path: '/car/carQuery',
    component: resolve => require(['Views/Car/carQuery/index.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'carList',
    path: '/car/carList',
    component: resolve => require(['Views/Car/carQuery/carList.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'carEdit',
    path: '/car/carEdit',
    component: resolve => require(['Views/Car/carQuery/carEdit.vue'], resolve),
    meta: {
      include: [],
      index: 3
    }
  },
  {
    name: 'carCmp',
    path: '/car/carCmp',
    component: resolve => require(['Views/Car/carQuery/carCmp.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
  {
    name: 'carOrderDetail',
    path: '/car/carOrderDetail',
    component: resolve => require(['Views/Car/carOrder/detail.vue'], resolve),
    meta: {
      include: [],
      index: 5
    }
  },
  {
    name: 'carJsycDetail',
    path: '/car/carJsycDetail/:id',
    component: resolve => require(['Views/Car/carOrder/jsycDetail.vue'], resolve),
    props: true,
    meta: {
      include: [],
      index: 5
    }
  }
]
